import { createFileRoute } from '@tanstack/react-router'
import { SignatureRequestPage } from '../../../components/signatures/SignatureRequestPage'

/** One signature request: its signers and its evidence journal (spec 2026-10-05-05). */
export const Route = createFileRoute('/$org/signatures/$uid')({
  component: SignatureRequestPage,
})
